import { fromPromise } from 'xstate5';

import type {
  BackgroundLocationPermissionStatus,
  LocationPermissionStatus,
  PushNotificationPermissionStatus,
  RequestBackgroundLocationPermissionOutput,
  RequestLocationPermissionOutput,
  RequestPushNotificationPermissionOutput,
} from '../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getPushNotificationPermissionStatus = fromPromise<PushNotificationPermissionStatus>(
  async () => {
    throw new Error('`getPushNotificationPermissionStatus` actor is not provided.');
  },
);

export const requestPushNotificationPermission =
  fromPromise<RequestPushNotificationPermissionOutput>(async () => {
    throw new Error('`requestPushNotificationPermission` actor is not provided.');
  });

export const getLocationPermissionStatus = fromPromise<LocationPermissionStatus>(async () => {
  throw new Error('`getLocationPermissionStatus` actor is not provided.');
});

export const requestLocationPermission = fromPromise<RequestLocationPermissionOutput>(async () => {
  throw new Error('`requestLocationPermission` actor is not provided.');
});

export const getBackgroundLocationPermissionStatus =
  fromPromise<BackgroundLocationPermissionStatus>(async () => {
    throw new Error('`getBackgroundLocationPermissionStatus` actor is not provided.');
  });

export const requestBackgroundLocationPermission =
  fromPromise<RequestBackgroundLocationPermissionOutput>(async () => {
    throw new Error('`requestBackgroundLocationPermission` actor is not provided.');
  });
